var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.68 65.118a63.1 63.1 0 0 0-1-11.25h-51.8v21.275h29.6a25.3 25.3 0 0 1-10.975 16.6v13.8h17.775c10.4-9.575 16.4-23.674 16.4-40.425Z",
    fill: "#3e82f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88 118.868c14.85 0 27.3-4.925 36.4-13.325l-17.775-13.8a33.058 33.058 0 0 1-18.625 5.25c-14.325 0-26.45-9.675-30.775-22.675H15.73v14.25a54.977 54.977 0 0 0 49.15 30.3Z",
    fill: "#32a753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1 74.318a32.515 32.515 0 0 1 0-20.9V39.169H15.73a55.067 55.067 0 0 0 0 49.4L34.1 74.318Z",
    fill: "#f9bb00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88 30.743a29.72 29.72 0 0 1 21.026 8.225l15.774-15.774a52.858 52.858 0 0 0-36.8-14.326 54.98 54.98 0 0 0-49.15 30.3l18.37 14.25c4.325-13 16.45-22.675 30.775-22.675Z",
    fill: "#e74133"
  }))));
};
export default SvgGoogle;